import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { GET_TINYKEY } from '../../../client/__graphql__/queries/other/getTinyKey';
import { getAdminClient } from '../../components/layout/admin/AdminApolloClient';
const client = getAdminClient();

export interface TinyProps {
  tinyLoaded: boolean;
  triggerTiny: (element: string, height?: number) => void;
  data: { name: string; value: string };
}

export const useTiny = (): TinyProps => {
  const [tinyLoaded, setTinyLoaded] = useState(false);
  const [data, setData] = useState<any>({});

  const { data: tinykey, loading } = useQuery(GET_TINYKEY, {
    fetchPolicy: 'cache-and-network',
    client
  });

  useEffect(() => {
    const key = tinykey?.getTinyKey ?? null;
    if (key) {
      const script = document.createElement('script');
      script.src = `https://cdn.tiny.cloud/1/${key}/tinymce/5-stable/tinymce.min.js`;
      script.addEventListener('load', () => {
        setTinyLoaded(true);
      });
      document.body.appendChild(script);
    }
  }, [tinykey]);

  const triggerTiny = (element: string, height?: number) => {
    if (typeof window !== 'undefined' && tinyLoaded === true) {
      window.tinymce.init({
        selector: element,
        plugins: ['link', 'paste'],
        height: height ? height : 300,
        init_instance_callback: function (editor: any) {
          editor.on('keyup change', (e: any) => {
            //console.log(editor.getContent());
            setData({
              ...data,
              name: editor.id,
              value: editor.getContent()
            });
          });
        },
        paste_as_text: true,
        toolbar:
          'undo redo | styleselect | ' +
          'bold italic | alignleft aligncenter ' +
          'alignright alignjustify | outdent indent | ' +
          'link | removeformat',
        menubar: false,
        /* plugins: [
          'advlist autolink lists link image charmap print preview anchor',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
        ],
        toolbar:
          'undo redo | formatselect | ' +
          'bold italic backcolor | image | alignleft aligncenter ' +
          'alignright alignjustify | bullist numlist outdent indent | ' +
          'removeformat | help',
          */
        content_style: ''

        // 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
      });
    }
  };

  return { tinyLoaded, triggerTiny, data };
};
